/* eslint react/jsx-pascal-case: 0 */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { style } from 'styled-system'
import Flex from '../Flex'
import Box from '../Box'
import Copy from '../Copy'
import Button from '../Button'
import {themeColor} from '../../util/themeLenses'
import * as styles from '../../util/styles'
import Icon from '../Icon'
import { isIFrame } from '@elparking/utils'


const animation = style({
    prop: 'animation',
    cssProperty: 'animation',
})

const top = style({
    prop: 'top',
    cssProperty: 'top',
})

const Container = styled(Box)`
    position: ${({ rollUpMessage }) => rollUpMessage ? 'absolute' : 'relative'};
    left: 0;
    right: 0;
    top: 0;
    min-height: 100%;
    z-index: 10;
    transition: ${({ transition }) => transition};
`

const Content = styled(Box)`
    ${styles.space};
    ${styles.borderRadius};
    background: ${themeColor('white')};
    position: ${({ rollUpMessage, backgroundPosition }) => rollUpMessage ? backgroundPosition : 'relative'};
    left: 0;
    bottom: 0;
    right: 0;
    @keyframes moveUp {
        0% {
            bottom: -100px;
        }
        100% {
            bottom: 0;
        }
    }
    ${animation};
    ${top};
`

const InfoMessage = ({ message, simple, title, image, show, animated, rollUpMessage, actionButton, textButton, secondaryButton, onClose, backgroundPosition }) => {
    const animationEnable = rollUpMessage && animated
    return show ? <Container
      rollUpMessage={rollUpMessage}
      background={rollUpMessage ? 'linear-gradient(180deg, transparent, rgba(0,0,0,0.3) 40%)' : 'white'}
      transition={rollUpMessage ? '0.2s' : '0s'}>
        <Content
          rollUpMessage={rollUpMessage}
          dataTest='info-message'
          minHeight={animationEnable ? ['auto', '0'] : '100%'}
          top={animationEnable ? ['auto', '0'] : '0'}
          display={animationEnable ? ['block', 'flex'] : 'flex'}
          borderRadius={animationEnable ? ['20px 20px 0 0', '0'] : '0'}
          animation={animationEnable ? ['moveUp 0.5s', 'none'] : 'none'}
          padding={rollUpMessage ? '20px' : 0}
          backgroundPosition={backgroundPosition}>
            <Flex
              height={animationEnable ? 'auto' : ['100%', 'auto']}
              flexDirection='column'
              justifyContent='space-between'
              width='100%'
              alignSelf='center'
              alignItems='center'
            >
                <Box w='100%' height='80%'>
                    {(rollUpMessage && !simple && onClose) && <Box textAlign='right' display={['block', 'none', 'none']}>
                        <Button.unstyled onClick={onClose} dataTest='close-info-message-button'>
                            <Icon type='x' fontSize='medium' fontColor='gray' />
                        </Button.unstyled>
                    </Box>}
                    {(!simple && image) && <Box mb='10px' textAlign='center'>{image}</Box>}
                    <Copy
                      marginTop='16px'
                      fontSize='xxLarge'
                      fontWeight='medium'
                      fontColor='darkGray'
                    >
                        {title}
                    </Copy>
                    {message}
                </Box>
                <Flex width='100%' height='20%' alignItems='end' flexDirection='column'>
                    <Box mt='1em' width='100%' textAlign={simple ? 'right' : 'center'}>
                        <Button
                          dataTest='info-message-primary-button'
                          onClick={actionButton}
                          width={simple ? 'auto' : '100%'}
                          fontWeight='regular'>
                            {textButton}
                        </Button>
                    </Box>
                    {secondaryButton}
                </Flex>
            </Flex>
        </Content>
    </Container > : null
}

InfoMessage.defaultProps = {
    rollUpMessage: !isIFrame(),
    simple: false,
    show: false,
    animated: false,
    textButton: <FormattedMessage id='continue' defaultMessage='Continuar' />,
    showCloseButton: false,
    onClose: null,
    backgroundPosition: 'absolute',
}

InfoMessage.propTypes = {
    image: PropTypes.node,
    message: PropTypes.node,
    show: PropTypes.bool,
    rollUpMessage: PropTypes.bool,
    title: PropTypes.node,
    actionButton: PropTypes.func.isRequired,
    secondaryButton: PropTypes.node,
    textButton: PropTypes.node.isRequired,
    animated: PropTypes.bool,
    simple: PropTypes.bool,
    onClose: PropTypes.func,
    backgroundPosition: PropTypes.string,
}

export default InfoMessage

